interface TopicItem {
  label: string;
  count: string;
}

const topics: TopicItem[] = [
  { label: '#2026夏季新番', count: '128万讨论' },
  { label: '#剑与魔法', count: '96万讨论' },
  { label: '#国漫崛起', count: '85万讨论' },
  { label: '#日漫推荐', count: '73万讨论' },
  { label: '#韩漫入坑', count: '61万讨论' },
  { label: '#恋爱番推荐', count: '55万讨论' },
  { label: '#异世界题材', count: '48万讨论' },
  { label: '#动漫壁纸', count: '42万讨论' },
  { label: '#追番日记', count: '37万讨论' },
  { label: '#动漫OST', count: '31万讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            动漫迷正在热议的话题，加入讨论发现同好
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, idx) => (
            <div
              key={idx}
              className="group cursor-pointer inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-100 hover:bg-accent-100 border border-background-200/70 hover:border-accent-300 transition-colors whitespace-nowrap"
            >
              <span className="text-sm font-medium text-foreground-700 group-hover:text-accent-700 transition-colors">
                {topic.label}
              </span>
              <span className="text-xs text-foreground-400 group-hover:text-accent-500 transition-colors">
                {topic.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}